import React from 'react';
import { Badge } from '../ui/badge';

const TYPE_CONFIG = {
  NATIONAL:  { className: 'bg-blue-500' },
  REGIONAL:  { className: 'bg-purple-500' },
  RELIGIOUS: { className: 'bg-green-500' },
  COMPANY:   { className: 'bg-orange-500' },
  OPTIONAL:  { className: 'bg-gray-500' },
};

export const getTypeBadge = (type, t) => {
  const config = TYPE_CONFIG[type] || TYPE_CONFIG.NATIONAL;
  return <Badge className={config.className}>{t ? t(`holidayCommon.types.${type}`, { defaultValue: type }) : type}</Badge>;
};

export const formatShortDate = (dateString, language) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString(language, {
    day: '2-digit', month: '2-digit', year: 'numeric',
  });
};

export const getDaysUntil = (dateString) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const holidayDate = new Date(dateString);
  holidayDate.setHours(0, 0, 0, 0);
  return Math.ceil((holidayDate - today) / (1000 * 60 * 60 * 24));
};

export const getDayOfWeek = (dateString, language) =>
  new Date(dateString).toLocaleDateString(language, { weekday: 'long' });
